import type {DeliveryInterval} from 'src/shared/types'

import {convertToStandardDate} from './convert-to-standard-date'

type DateInterval = string

export const mapDeliveryIntervals = (
  deliveryIntervals: DeliveryInterval[],
): Record<DateInterval, Array<DeliveryInterval>> => {
  return deliveryIntervals.reduce<Record<DateInterval, Array<DeliveryInterval>>>((acc, interval) => {
    const date = convertToStandardDate(interval.from)

    if (date === undefined) {
      return acc
    }

    const dateIntervals = acc[date]
    if (dateIntervals === undefined) {
      acc[date] = [interval]
    } else {
      dateIntervals.push(interval)
    }

    return acc
  }, {})
}
